import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import ButtonLink, { ButtonLinkStyles } from '../../components/ButtonLink';
import QA from '../../constants/QATags';
import { getBrowsePath, getBrowsePodcastsPath } from '../../lib/RouteUtils';

import './BrowseCta.scss';

const intlMessages = defineMessages({
  browsePodcastsLabel: {
    id: 'BrowseCta.browsePodcastsLabel',
    defaultMessage: 'Want help finding more Podcasts?',
  },
  browseLabel: {
    id: 'BrowseCta.browseLabel',
    defaultMessage: 'Want help finding something new?',
  },
  browseGenresButton: {
    id: 'BrowseCta.browseGenresButton',
    defaultMessage: 'Browse Genres',
  },
  browseButton: {
    id: 'BrowseCta.browseButton',
    defaultMessage: 'Browse',
  },
  browsePodcastsButton: {
    id: 'BrowseCta.browsePodcastsButton',
    defaultMessage: 'Browse Podcasts',
  },
});

class BrowseCta extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    labelRequired: PropTypes.bool,
    isPodcastFilter: PropTypes.bool,
  };

  static defaultProps = {
    labelRequired: true,
  };

  renderLabel = () => {
    return (
      <div className='BrowseCta__label'>
        {this.props.isPodcastFilter
          ? this.props.intl.formatMessage(intlMessages.browsePodcastsLabel)
          : this.props.intl.formatMessage(intlMessages.browseLabel)}
      </div>
    );
  };

  renderButtonLink = () => {
    let path;
    let title;
    let qaTag;

    if (this.props.isPodcastFilter) {
      path = getBrowsePodcastsPath();
      title = intlMessages.browsePodcastsButton;
      qaTag = QA.BPB;
    } else {
      path = getBrowsePath();
      title = intlMessages.browseButton;
      qaTag = QA.BB;
    }

    return (
      <ButtonLink
        styleNames={[ButtonLinkStyles.CTA, ButtonLinkStyles.CTA_T3]}
        to={path}
        title={title}
        qaTag={qaTag}
      />
    );
  };

  render() {
    return (
      <div className='BrowseCta'>
        {this.props.labelRequired && this.renderLabel()}
        {this.renderButtonLink()}
      </div>
    );
  }
}

export default injectIntl(BrowseCta);
